var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageFill = function SvgMessageFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#message-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.272 16.039a.898.898 0 0 1-.535-.83v-2.684h-2.15C1.16 12.525 0 11.321 0 9.841V2.684C0 1.204 1.161 0 2.587 0H14.22c1.426 0 2.587 1.205 2.587 2.684v7.157c0 1.48-1.161 2.684-2.586 2.684H9.405l-3.196 3.317a.838.838 0 0 1-.937.197Zm13.341 5.17-3.196-3.315h-3.092c-1.426 0-2.587-1.205-2.587-2.684 0-.496.385-.895.862-.895s.862.4.862.895.386.894.863.894h3.449c.23 0 .448.096.609.263l1.977 2.052v-1.42c0-.495.385-.895.862-.895h2.191c.477 0 .863-.4.863-.894V8.052c0-.495-.386-.895-.863-.895H19.05c-.477 0-.862-.4-.862-.894 0-.495.385-.895.862-.895h2.363C22.84 5.368 24 6.573 24 8.052v7.158c0 1.479-1.161 2.684-2.587 2.684h-1.329v2.684a.904.904 0 0 1-.534.829.838.838 0 0 1-.937-.197ZM5.811 6.064a1.01 1.01 0 1 1-2.021 0 1.01 1.01 0 1 1 2.021 0Zm4.042 0a1.01 1.01 0 1 1-2.021 0 1.01 1.01 0 1 1 2.021 0Zm3.031 1.01c.56 0 1.01-.45 1.01-1.01 0-.559-.45-1.01-1.01-1.01a1.01 1.01 0 1 0 0 2.021Z",
    fill: "#FF5C7F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v22H0z"
  })))));
};
export default SvgMessageFill;